export default {
    type: 'string',
    readOnly: true,
    default: ''
};
